<h1 mat-dialog-title>Subscription Canceled</h1>
<div mat-dialog-content>Your subscription has been cancelled.</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>Close</button>
</div>
